<template>
  <div @click="$emit('change')" class="checkbox">
    <div class="box">
      <svg
        v-if="isChecked"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        class="box-background"
      >
        <rect width="16" height="16" rx="2" />
        <path
          d="M3.5 8.66667L5.86842 11L12.5 4"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-else
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8333 0.5H2.16667C1.24619 0.5 0.5 1.24619 0.5 2.16667V13.8333C0.5 14.7538 1.24619 15.5 2.16667 15.5H13.8333C14.7538 15.5 15.5 14.7538 15.5 13.8333V2.16667C15.5 1.24619 14.7538 0.5 13.8333 0.5Z"
          fill="inherit"
          stroke="#C2C2D6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <p class="text mb-0">{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    isChecked: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.checkbox {
  line-height: 18px;
  display: flex;
  align-items: center;
  .box {
    margin-right: 8px;
    &-background {
      fill: $primary-color2;
    }
  }
  .text {
    margin-top: 2px;
    color: $title-color;
  }
}

.filter {
  .checkbox {
    .text {
      line-height: 22px;
    }
  }
}

#app[data-theme='dark'] {
  .checkbox {
    .text {
      color: #d6d6d6;
    }
  }
}
</style>
